import { AppContext } from 'App.context';
import { useContext } from 'react';

export const useApp = () => useContext(AppContext);
